import React from 'react'
import { useParams } from 'react-router-dom'
import { ChangePassword as ChangePasswordCore } from '@ztechapps/webui.auth'
import { routesDef } from '../../../config/routes'
import { AccountRegisterContainer } from '../../../components/AccountRegisterContainer'
import { appSettings } from '../../../config/settings'
import { PageTitle } from '../../../components/PageTitle'

export const Page = () => {
  const { username: resetUsername, code: resetCode } = useParams()
  const recaptchaSiteKey = appSettings.Google.recaptchaSiteKey

  const content = (
    <ChangePasswordCore
      url={`/api/auth/basic/pp-store/change-password`}
      resetUsername={resetUsername}
      resetCode={resetCode}
      navigateTo={routesDef.LoginPage.path}
      recaptchaSiteKey={recaptchaSiteKey}
    />
  )

  return (
    <AccountRegisterContainer>
      <PageTitle
        title="Change Password"
        description="Update your account password. Choose a strong, unique password for security."
      />
      <h4>Change password</h4>
      {content}
    </AccountRegisterContainer>
  )
}
